export default __webpack_public_path__ + "static/media/logoHeader435x383.b9f6d28c.png";